// extracted by mini-css-extract-plugin
module.exports = {"SubHero":"sub-hero-module--SubHero--7V7gh"};